import useSWR from "swr";
import investServices from "@/services/apiServices/investServices/index.js";

const usePositions = () => {
  return useSWR(`getPositionFiles`, investServices.getPositionFiles);
};

export default usePositions;
